module.exports = __webpack_public_path__ + "img/256_Third of Brookfield_Lobby_cam01_D4.ea5267fb.jpg";